/* eslint-disable eqeqeq */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatName } from "../../../lib/Misc";
import { VerifiedIcon } from "lucide-react";

const ExpandCDD = ({ expandData }) => {
  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData[i]?.id,
        verification_document_type: expandData[i]?.verification_document_type
          ?.label
          ? expandData[i]?.verification_document_type?.label
          : "",
        date_verified: expandData[i]?.date_verified
          ? expandData[i]?.date_verified
          : "",
        verified_by: expandData[i]?.verified_by
          ? formatName(
              expandData[i]?.verified_by?.first_name,
              expandData[i]?.verified_by?.last_name,
            )
          : "",
        method: expandData[i]?.method_title ? expandData[i]?.method_title : "",
        verified_status: expandData[i]?.verified_using ? (
          <VerifiedIcon size={18} className="text-green-500" />
        ) : (
          ""
        ),
      });
    }
    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verification_document_type",
      text: "Document Type",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "date_verified",
      text: "Date Verified",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verified_by",
      text: "Verified By",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "method",
      text: "Method",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verified_status",
      text: "Verified",
    },
  ];

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </div>
    </>
  );
};

export default ExpandCDD;
